<script setup lang="ts">
import type { IHeroBanner } from './types'
import WidgetHeroBannerLayout from './layout'
import WidgetHeroBannerIllustration from './illustration'

const props = withDefaults(defineProps<IHeroBanner>(), {
  highPriority: true
})
</script>

<template>
  <WidgetHeroBannerLayout width="wide" class="h-full" :backdrop="props.backdrop">
    <div v-if="props.intro" class="md:text-lg">{{ props.intro }}</div>
    <Heading v-if="props.heading" tag="h1">{{ props.heading }}</Heading>
    <div
      v-if="props.text"
      v-hydrated-html="props.text"
      class="max-w-2xl space-y-3 leading-6 text-gray-700 md:leading-7 lg:[&>p+p]:hidden 2xl:[&>p+p]:block [&_b]:font-semibold [&_b]:text-brand-gray [&_strong]:font-semibold [&_strong]:text-brand-gray"
    />
    <div class="mt-1 flex flex-row items-center gap-2 md:gap-3">
      <Button v-if="props.actionBtn" as-child class="px-3">
        <NuxtLinkLocale :to="props.actionBtn.url">{{ $t(props.actionBtn.label) }}</NuxtLinkLocale>
      </Button>
      <Button v-if="props.additionalActionBtn" variant="orange" as-child>
        <NuxtLinkLocale :to="props.additionalActionBtn.url">{{
          $t(props.additionalActionBtn.label)
        }}</NuxtLinkLocale>
      </Button>
    </div>

    <template v-if="props.illustration || props.image" #illustration>
      <WidgetHeroBannerIllustration v-if="props.illustration" :name="props.illustration" />
      <NuxtImg
        v-else-if="props.image"
        :src="props.image"
        :alt="props.heading"
        class="pointer-events-none size-[18.5rem] select-none object-contain"
        format="avif,webp"
        :fetchpriority="props.highPriority ? 'high' : 'auto'"
        :loading="props.highPriority ? 'eager' : 'lazy'"
        :preload="props.highPriority"
        sizes="(min-width: 1024px) 296px, 1px"
      />
    </template>
  </WidgetHeroBannerLayout>
</template>
